module.exports = "/assets/site/images/MVM_sieles.jpg?931ea0c98fb19e7b07d40eaea84e8a06";